// ===== ACTION TYPES =====
export const ADD_WORK_FILE = "ADD_WORK_FILE";
export const SET_WORK_FILES_FOR_WORK = "SET_WORK_FILES_FOR_WORK";
export const DELETE_WORK_FILE = "DELETE_WORK_FILE";
export const SET_WORK_FILE_LOADING = "SET_WORK_FILE_LOADING";

// ===== ACTIONS =====
export const addWorkFile = (file) => ({
  type: ADD_WORK_FILE,
  payload: file
});

export const setWorkFilesForWork = (workId, files) => ({
  type: SET_WORK_FILES_FOR_WORK,
  payload: { workId, files }
});

export const deleteWorkFileFromStore = (fileId) => ({
  type: DELETE_WORK_FILE,
  payload: fileId
});

export const setWorkFileLoading = (loading) => ({
  type: SET_WORK_FILE_LOADING,
  payload: loading
});

// ===== INITIAL STATE =====
const initialState = {
  files: [],
  loading: false
};

// ===== REDUCER =====
export const workFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_WORK_FILE:
      return {
        ...state,
        files: [...state.files, action.payload]
      };

    case SET_WORK_FILES_FOR_WORK:
      return {
        ...state,
        files: [
          ...state.files.filter(
            (f) => f.work?.workId !== action.payload.workId
          ),
          ...action.payload.files
        ]
      };

    case DELETE_WORK_FILE:
      return {
        ...state,
        files: state.files.filter((f) => f.fileId !== action.payload)
      };

    case SET_WORK_FILE_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};
